import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/form_fields/index.vue') }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/form_fields/show.vue') }

  static values = {
    formFieldId: String
  }

  connect() {
    super.connect({
      formFieldId: this.formFieldIdValue
    })
  }
}
